document.addEventListener('click', function(event) {
  const button = event.target.closest('.fl-product-description__toggle');
  if (!button) return;
  const wrap = button.closest('.fl-product-description');
  if (!wrap) return;
  const expanded = wrap.classList.toggle('is-expanded');
  button.setAttribute('aria-expanded', String(expanded));
  button.innerHTML = expanded ? 'Read less <span aria-hidden="true">↑</span>' : 'Read more <span aria-hidden="true">↓</span>';
});


/* Form Lisbon v1.8: reveal header on upward scrolling only */
(function () {
  function setupHeader() {
    const header = document.querySelector('.fl-site-header');
    if (!header || header.dataset.scrollInit === 'true') return;
    header.dataset.scrollInit = 'true';
    let lastY = Math.max(0, window.scrollY);
    let scheduled = false;
    function update() {
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      if (y <= 90) {
        header.classList.remove('fl-site-header--hidden');
      } else if (delta > 3) {
        header.classList.add('fl-site-header--hidden');
      } else if (delta < -3) {
        header.classList.remove('fl-site-header--hidden');
      }
      lastY = y;
      scheduled = false;
    }
    window.addEventListener('scroll', function () {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupHeader);
  } else {
    setupHeader();
  }
})();
